import React, { useState } from 'react';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';

export const columns = [
  {
    column: 'order',
    label: '順序',
    className: 'first',
  },
  {
    column: 'player.number',
    label: '背號',
  },
  {
    column: 'player.name',
    label: '名稱',
  },
  {
    column: 'IP_out',
    label: '出局數',
    updatable: Number,
  },
  {
    column: 'NP',
    label: '投球數',
    updatable: Number,
  },
  {
    column: 'BF',
    label: '面對打者',
    updatable: Number,
  },
  {
    column: 'H',
    label: '安打',
    updatable: Number,
  },
  {
    column: 'HR',
    label: '全壘打',
    updatable: Number,
  },
  {
    column: 'BB',
    label: '保送',
    updatable: Number,
  },
  {
    column: 'IBB',
    label: '故意四壞',
    updatable: Number,
  },
  {
    column: 'HB',
    label: '觸身',
    updatable: Number,
  },
  {
    column: 'SO',
    label: '三振',
    updatable: Number,
  },
  {
    column: 'WP',
    label: '暴投',
    updatable: Number,
  },
  {
    column: 'BK',
    label: '投手犯規',
    updatable: Number,
  },
  {
    column: 'R',
    label: '失分',
    updatable: Number,
  },
  {
    column: 'ER',
    label: '責失',
    updatable: Number,
  },
];

const FormalGameBoxPitching = ({ players, pitchings, handleUpdate }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');

  return (
    <div>
      {getUpdateDiv(pitchings, columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn, handleUpdate)}
      <StyledTableWrapper>
        {tableRender(pitchings, columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn)}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGameBoxPitching;
